import script from "./AIChatAgentKnowledgeBase.vue?vue&type=script&setup=true&lang=js"
export * from "./AIChatAgentKnowledgeBase.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__